import { render, staticRenderFns } from "./PieChart2.vue?vue&type=template&id=9b7fcd76&scoped=true"
import script from "./PieChart2.vue?vue&type=script&lang=js"
export * from "./PieChart2.vue?vue&type=script&lang=js"
import style0 from "./PieChart2.vue?vue&type=style&index=0&id=9b7fcd76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7fcd76",
  null
  
)

export default component.exports